import { IconButton, InputBase, Typography } from "@mui/material";
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { saveAs } from "file-saver";

import { Box, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import Stack from "@mui/material/Stack";
import { tokens } from "../../theme";
import GreetingHeader from "../../components/GreetingHeader";
import SectionHeader from "../../components/SectionHeader";
import CustomButton from "../../components/CustomButton";
import Grid from "@mui/material/Unstable_Grid2";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import { getFromLocalStorage, getFromLocalStorageJsonObject } from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import DownloadDropdownButton from "../../components/DownloadDropdownButton";
import { useAtom } from "jotai";
import * as CONSTANT from "../../constants/Constant";
import isEmptyArray from "lodash/isEmpty";
import ToolbarFilterButton from "../../components/ToolbarFilterButton";

import {
  globalSearchText,
  selectedItems,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  LOADING_TIMELINE,
  SOME_ERROR_OCCURRED,
} from "../../constants/Strings";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  LOGIN_RESPONSE,
  MESSAGE_KEY,
  SESSION_ID,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import {
  getCashOutHeaderDetails,
  getCashOutLimitActivityDetails,
  getCashOutLimitDetails,
  getCashOutTimelineDetails,
  getCashOutTierValue,
  configureCashOutLimitForSelectedDealer,
  getCashOutGlobalLimitDetails,
  configureCashOutGlobalSetting,
  downloadCashOutLimitReports
} from "../../services/ApiService";
import { useNavigate } from "react-router-dom";
import { cashOutLimitsColumnHeader } from "../../components/ColumnHeader";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import UserActivityInfo from "../../components/UserActivity";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import EarmarkHighlightStats from "../../components/EarmarkHighlightedStats";
import {formatPrice} from "../../utils/PriceFormatter";
import SetCashOutLimitDialog from "./SetCashOutLimitDialog";

export function CashOutLimitsScreen() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const isNetworkConnectionAvailable = UseOnlineStatus();

  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  // search bar & filter
  const [searchQueryPlaceholder, setSearchQueryPlaceholder] = useState("Search Name");
  const [searchDealerQuery, setDealerSearchQuery] = useState("");
  const [filter, setFilter] = useState("");
  const [filterCriteria, setFilterCriteria] = useState([{ "keyValue":"","displayName": "", "paramName": "" }]);
  const [filterDisplayOptions, setFilterDisplayOptions] = useState([]);
  const [defaultFilter, setDefaultFilter] = useState("Name");
  const [showTierDropdown, setShowTierDropdown] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  
  // header
  const [totalAccounts, setTotalAccounts] = useState(0);  
  const [tierData, setTierData] = useState({});
  const tierKeys = Object.keys(tierData);
  const props = {};

  tierKeys.forEach((key, index) => {
    props[`highlight${index + 1}`] = key;
    props[`highlight${index + 1}Stat`] = tierData[key];
  });

  const [cashOutLimitDetails, setCashOutLimitDetails] = useState([]);
  const [cashOutTimelineDetails, setCashOutTimelineDetails] = useState([]);
  const [cashOutActivityDetails, setCashOutActivityDetails] = useState([]);

  const [selectedDateRange, setSelectedDateRange] = useState(CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS); 
  // const [fromDate, setFromDate] = useState(new Date(toDate.setMonth(toDate.getMonth() - 3)));


  // dialog for cash out limit
  const [openCashOutLimitDialog, setOpenCashOutLimitDialog] = useState(false);
  const [tierTabs, setTierTabs] = useState([]);
  const [selectedTier, setSelectedTier] = useState("");
  const [globalCashOutLimitDetails, setGlobalCashOutLimitDetails] = useState([]);
  const [isGlobalDataExist, setIsGlobalDataExist] = useState(false);

  // cash out limit grid data
  const [selectedItem, setSelectedItem] = useAtom(selectedItems);   // for single row click
  const [selectedRows, setSelectedRows] = React.useState([]);   // for multiple row checkbox selection
  const [selectedRowData, setSelectedRowData] = useState([]);   // for multiple row checkbox selection

  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  // pagination for Earmark
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  // pagination for Activity
  const [activityPageSize, setActivityPageSize] = useState(8);
  const [activityCurrentPage, setActivityCurrentPage] = useState(0);
  const [activityTotalNoOfPages, setActivityTotalNoOfPages] = useState(0);

  // pagination for Timeline
  const [timelinePageSize, setTimelinePageSize] = useState(10);
  const [timelineCurrentPage, setTimelineCurrentPage] = useState(0);
  const [timelineTotalNoOfPages, setTimelineTotalNoOfPages] = useState(0);

  const [searchQuery, setSearchQuery] = useAtom(globalSearchText);

  // buttons visibility
  const [hasEditAccess, setEditAccess] = useState(false);
  const [downloadButtonVisible, setDownloadButton] = useState(false);
  const [globalSettingsButton, setGlobalSettingsButton] = useState(false);
  const [isGlobalCashOutLimitDialog, setIsGlobalCashOutLimitDialog] = useState(false);

  // sort model
  const [sortModel, setSortModel] = useState([]);

  // sorting handling 
  useEffect(() => {
    getCashOutLimitDetailsData(paginationModel.page, paginationModel.pageSize, filter, searchDealerQuery);
  }, [sortModel]);

  useEffect(() => {
    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  // Fetch data on page load
  useEffect(() => {
    getHeaderSummary();
    getCashOutLimitDetailsData(paginationModel.page, paginationModel.pageSize, filter, searchDealerQuery);
    getActivityDetails(activityCurrentPage, selectedDateRange);
    getTierArrayForTabs();
    
    updateButtonVisibility();
    setupFilters()
  }, []);

  const updateButtonVisibility = () => {
    const sessionId = getFromLocalStorage(SESSION_ID);
    try {
      if (sessionId !== "") {
        const userDetails = getFromLocalStorageJsonObject(LOGIN_RESPONSE);
      
        let cashOutMenuItem = [];

        if (!isEmptyArray(userDetails)) {
          let menuListSize = userDetails.length;
          if (menuListSize != null && menuListSize > 0) {
            userDetails.forEach((item, index) => {
              if (item.menuListName === "Cash Out Limit") {
                cashOutMenuItem = [...item.menuItem];
              }
            });

            cashOutMenuItem.forEach((itemA, index) => {
              if (itemA.menuName === "Cash Out Limit") {
                const actionButtonList = [...itemA.actionButton];
                DebugLog("actionButtonList from sidebar    " + JSON.stringify(actionButtonList))

                actionButtonList.forEach((items, index) => {
                 
                    if (items.buttonName === "DOWNLOAD") {
                      setDownloadButton(true)
                    } else if(items.buttonName === "GLOBAL SETTINGS"){
                      setGlobalSettingsButton(true)
                    } else if(items.buttonName === "VIEW"){
                      // set view only
                    } else if(items.buttonName === "EDIT"){
                      setEditAccess(true)
                    }
                  });
                }
            });
          }
        }
      }
    } catch (error) {
      DebugLog(error);
    }
  };

  const handleDateRangeChange = (selectedDateRange) => {
    setSelectedDateRange(selectedDateRange);
    getActivityDetails(activityCurrentPage, selectedDateRange);
  }

  // create async funtion to fetch data to refresh page
  const handleRefresh = async () => {
    await Promise.all([
      getHeaderSummary(),
      getCashOutLimitDetailsData(paginationModel.page, paginationModel.pageSize, filter, searchDealerQuery),
      getActivityDetails(activityCurrentPage, selectedDateRange)
    ]);
  };


  const handleCloseCashOutLimitDialog = () => {
    setOpenCashOutLimitDialog(false);
    DebugLog("Dialog Closed");
  };

  /******** Row Checkbox Selection Handling *******/
  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
    
    // save selected row data in a state
    const updatedSelection = [];
    newSelection.forEach(rowId => {
      
    });
    setSelectedRowData(updatedSelection);
  };

  const resetSelection = () => {
    setSelectedRows([]);
  };


  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });

    getCashOutLimitDetailsData(newPage, paginationModel.pageSize, filter, searchDealerQuery);
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });

    getCashOutLimitDetailsData(newPage, paginationModel.pageSize, filter, searchDealerQuery);
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });

    // call api with new page size and start from page 0. 
    // searchAllAccountEarmarkDetails(0, newPageSize);
    getCashOutLimitDetailsData(0, newPageSize, filter, searchDealerQuery);
  }

  const handleActivityPageChange = (newPage) => {
    setActivityCurrentPage(newPage);
    getActivityDetails(newPage, selectedDateRange);
  }

  /********  Timeline Pagination Methods ***********/
  const  handleTimelinePageChange = (newPage) => {
    setTimelineCurrentPage(newPage);
    getTimelineDetails(newPage, selectedItem, isGlobalCashOutLimitDialog, selectedTier);
  }

 
  // const filteredRows = cashOutLimitDetails.filter((row) =>
  //   Object.values(row).some((value) =>
  //     String(value).toLowerCase().includes(searchQuery.toLowerCase())
  //   )
  // );
const filteredRows = cashOutLimitDetails.filter((row) =>
  Object.values(row).some((value) =>
    value != null && String(value).toLowerCase().includes(searchQuery.toLowerCase())
  )
);
  /****** API CALLS *******/

  function getHeaderSummary() {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
        };

        getCashOutHeaderDetails(requestData)
        .then((response) => {
            // sample response data: { "responseId": "88888888","responseCode": "0","responseMessage": "Success","displayResponseMessage": "Success", "result": {"totalDealerCount": 51,"tierCount": {"Tier 1": 40,"Tier 2": 7,"Tier 3": 4}}}

            setTotalAccounts(response.data.result.totalDealerCount);
            setTierData(response.data.result.tierCount);
            setLoading(false);
        })
        .catch((error) => {
            handleError(error);
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  function getCashOutLimitDetailsData(pageNumber, pageSize, selectedFilter, searchQuery) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = createRequestObject(
          pageNumber,
          pageSize,
          selectedFilter,
          searchQuery
        )

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_CASH_OUT_LIMIT_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getCashOutLimitDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.cashOutLimitDetailPage.content.map((row) => ({
                  ...row,
                  id: row.accountCode + row.accountName,
                  daily: `${formatPrice(row.dailyTransactionAmount)} / ${row.dailyTransactionCount}X`,
                  weekly: `${formatPrice(row.weeklyTransactionAmount)} / ${row.weeklyTransactionCount}X`,
                  monthly: `${formatPrice(row.monthlyTransactionAmount)} / ${row.monthlyTransactionCount}X`,
                }));

              setCashOutLimitDetails(contentData);

              setRowsPerPage(response.data.result.cashOutLimitDetailPage.content.length);
              setTotalNoOfRows(response.data.result.cashOutLimitDetailPage.totalElements);
              setTotalNoOfPages(response.data.result.cashOutLimitDetailPage.totalPages);
              setLoading(false);
            })
            .catch((error) => {
              handleError(error);
            });
        }); 
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  function getTimelineDetails(pageNo, params, isGlobal, selectedTierForGlobal) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_TIMELINE);
        setLoading(true);

        // global timeline has different request object
        const requestObject = isGlobal ? {
          accountCode: "ALL",
          tier: selectedTierForGlobal,
          pageNumber: pageNo,
          pageSize: timelinePageSize,
        } : {
          accountCode: params.accountCode,
          tier: params.tier,
          pageNumber: pageNo,
          pageSize: timelinePageSize,
        }

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_CASH_OUT_TIMELINE_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getCashOutTimelineDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.cashOutLimitTimeLinePage.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
              setCashOutTimelineDetails(contentData);
              setTimelineTotalNoOfPages(response.data.result.cashOutLimitTimeLinePage.totalPages);
              setLoading(false);
            })
            .catch((error) => {
              handleError(error);
            });
        });

      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }
  

  function getActivityDetails(pageNo, passedDateRange) {
    try {
      if (isNetworkConnectionAvailable) {
        // setProgressbarText(LOADING_PLEASE_WAIT);
         setLoading(true);

        const toDate = new Date();
        let fromDate = new Date();

        switch(passedDateRange) {
          case CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 3);
            break;
          case CONSTANT.ACTIVITY_PERIODS.SIX_MONTHS:
            fromDate.setMonth(toDate.getMonth() - 6);
            break;
          case CONSTANT.ACTIVITY_PERIODS.ONE_YEAR:
            fromDate.setFullYear(toDate.getFullYear() - 1);
            break;
          default:
            fromDate.setMonth(toDate.getMonth() - 3); // default to 3 months if no valid option is selected
        }

        const requestObject = {
          pageNumber: pageNo,
          pageSize: activityPageSize,
          fromDate: fromDate,
          toDate: toDate,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_CASH_OUT_ACTIVITY_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getCashOutLimitActivityDetails(requestData)
            .then((response) => {
              const contentData =
                response.data.result.cashOutLimitActivityPage.content.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));
              setCashOutActivityDetails(contentData);
              setActivityTotalNoOfPages(response.data.result.cashOutLimitActivityPage.totalPages);
              setLoading(false);
            })
            .catch((error) => {
                handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }


  function downloadCashOutReport(fileType) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          // fromDate: params.fromDate,
          // toDate: params.toDate,
          // accountCode: params.code,
          // accountName: params.name,
          // tier: params.tier,

          reportTemplate: "CASHOUT_LIMIT_REPORT",
          reportFormat: fileType
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.CASH_OUT_LIMIT_REPORT_DOWNLOAD
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          downloadCashOutLimitReports(requestData)
            .then((response) => {
              setLoading(false);


              let blob;
              const currentDate = new Date();
              const day = String(currentDate.getDate()).padStart(2, '0');
              const month = String(currentDate.getMonth() + 1).padStart(2, '0');
              const year = String(currentDate.getFullYear());

              // let filename be "CashOutLimitReport_YYYY-MM-DD"
              let filename = `CashOutLimitReport${year}-${month}-${day}`;
              switch(fileType) {
                case 'CSV':
                  blob = new Blob([response.data], {type: 'text/csv'});
                  filename = filename + '.csv';
                  break;
                case 'XLS':
                  blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
                  filename = filename + '.xls';
                  break;
                case 'PDF':
                  blob = new Blob([response.data], {type: 'application/pdf'});
                  filename = filename + '.pdf';
                  break;

                default:
                  throw new Error('Invalid file type');
              } 

              // Use FileSaver to save the file
              saveAs(blob, filename);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }


  function getTierArrayForTabs() {
    try {
      if (isNetworkConnectionAvailable) {
        const requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          sessionId: getFromLocalStorage(SESSION_ID),
          loginUserName: getFromLocalStorage(USER_NAME),
        };

        getCashOutTierValue(requestData)
          .then((response) => {
            setTierTabs(response.data.result);
          })
          .catch((error) => {
            handleError(error);
          });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  // this function is called when user clicks on "SAVE" button in the dialog
  function saveCashOutLimit(formData) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          accountCode: formData.accountCode,
          tier: formData.tier,
          dailyTransactionCount: formData.dailyTransactionCount, 
          weeklyTransactionCount: formData.weeklyTransactionCount, 
          monthlyTransactionCount: formData.monthlyTransactionCount, 
          dailyTransactionAmount: formData.dailyTransactionAmount, 
          weeklyTransactionAmount: formData.weeklyTransactionAmount, 
          monthlyTransactionAmount: formData.monthlyTransactionAmount, 
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.SAVE_CASH_OUT_LIMIT_FOR_DEALER
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          configureCashOutLimitForSelectedDealer(requestData)
            .then((response) => {
              setLoading(false);

              if (response.data.responseCode === "0") {
                showErrorAlert("Success", response.data.displayResponseMessage)
              } else {
                showErrorAlert("Error", response.data.displayResponseMessage);
              }
              handleRefresh();
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  // this function is called when user clicks on "SAVE" button in the GLOBAL cash out limit dialog
  function saveGlobalCashOutLimit(globalCashOutLimit) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const modifiedGlobalCashOutLimit = globalCashOutLimit.map(({ accountName, accountCode, vendorCode, ...keepAttrs }) => keepAttrs);

        const requestObject = {
          cashOutLimitDetailRequestList: modifiedGlobalCashOutLimit,
          isUpdateExisting: isGlobalDataExist,
        }

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.SAVE_GLOBAL_CASH_OUT_LIMIT
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          configureCashOutGlobalSetting(requestData)
            .then((response) => {
              setLoading(false);

              if (response.data.responseCode === "0") {
                showErrorAlert("Success", response.data.displayResponseMessage)
              } else {
                showErrorAlert("Error", response.data.displayResponseMessage);
              }
              handleRefresh();
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }


  function getGlobalCashOutLimitDetails() {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          sessionId: getFromLocalStorage(SESSION_ID),
          loginUserName: getFromLocalStorage(USER_NAME),
        };

        getCashOutGlobalLimitDetails(requestData)
          .then((response) => {
            if (response.data.responseCode === "0") {
              if (response.data.result != null && response.data.result.cashOutLimitDetailPage.content != null) {
                if (Array.isArray(response.data.result.cashOutLimitDetailPage.content) && response.data.result.cashOutLimitDetailPage.content.length > 0) {
                  setIsGlobalDataExist(true);
                  setGlobalCashOutLimitDetails(response.data.result.cashOutLimitDetailPage.content);
                  openGlobalSettingsDialog()
                } else {
                  const emptyData = tierKeys.map(tier => ({
                    accountName: "",
                    accountCode: "",
                    vendorCode: "",
                    tier: tier,
                    dailyTransactionCount: "",
                    weeklyTransactionCount: "",
                    monthlyTransactionCount: "",
                    dailyTransactionAmount: "",
                    weeklyTransactionAmount: "",
                    monthlyTransactionAmount: ""
                  }))
                  setIsGlobalDataExist(false)
                  setGlobalCashOutLimitDetails(emptyData);
                  openGlobalSettingsDialog()
                }
              }
            } else {
              showErrorAlert("Error", response.data.displayResponseMessage);
            }

            setLoading(false);
          })
          .catch((error) => {
            handleError(error);
          });

      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  function openGlobalSettingsDialog() {
    setIsGlobalCashOutLimitDialog(true);
    setOpenCashOutLimitDialog(true);
    // getTimelineDetails(timelineCurrentPage, selectedItem, true, selectedTier);
  }

  function fetchGlobalCashOutLimitDetailsForDealer() {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestData = {
          requestId: generateRequestId(),
          loginId: getFromLocalStorage(LOGIN_ID),
          sessionId: getFromLocalStorage(SESSION_ID),
          loginUserName: getFromLocalStorage(USER_NAME),
        };

        getCashOutGlobalLimitDetails(requestData)
          .then((response) => {
            if (response.data.responseCode === "0") {
              if (response.data.result != null && response.data.result.cashOutLimitDetailPage.content != null) {
                if (Array.isArray(response.data.result.cashOutLimitDetailPage.content) && response.data.result.cashOutLimitDetailPage.content.length > 0) {
                  setIsGlobalDataExist(true);
                  setGlobalCashOutLimitDetails(response.data.result.cashOutLimitDetailPage.content);
                } else {
                  const emptyData = tierKeys.map(tier => ({
                    accountName: "",
                    accountCode: "",
                    vendorCode: "",
                    tier: tier,
                    dailyTransactionCount: "",
                    weeklyTransactionCount: "",
                    monthlyTransactionCount: "",
                    dailyTransactionAmount: "",
                    weeklyTransactionAmount: "",
                    monthlyTransactionAmount: ""
                  }))
                  setIsGlobalDataExist(false)
                  setGlobalCashOutLimitDetails(emptyData);
                }
              }
            } else {
              showErrorAlert("Error", response.data.displayResponseMessage);
            }

            setLoading(false);
          })
          .catch((error) => {
            handleError(error);
          });

      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }


  /****** Handle Methods *******/
  const handleRowClick = (params) => {
    if (hasEditAccess){
      fetchGlobalCashOutLimitDetailsForDealer();
      setIsGlobalCashOutLimitDialog(false);
      setSelectedItem(params.row);
      setOpenCashOutLimitDialog(true);
      getTimelineDetails(timelineCurrentPage, params.row, false)
    }
  };

  // call timeline details for selected dealer with added parameter for the selected tier
  const handleSelectedTierChangeForGlobal = (selectedTier) => {
    setSelectedTier(selectedTier);

    setTimelineCurrentPage(0);
    getTimelineDetails(0, selectedItem, true, selectedTier);
  };

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    } 

    const errorCode = error.data?.errorCode;
    var errorMessage =
        error.data != null
            ? error.data.displayErrorMessage
            : SOME_ERROR_OCCURRED;
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () => navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () => showErrorAlert(
        error.message,
        JSON.stringify(errorMessage)
      ),
    };
  
    (errorActions[errorCode] || errorActions.default)();
  }

  function showErrorAlert(title, content) {
    try {
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  /********** SEARCH & FILTER methods *************/
  function setupFilters() {
    const filterOptions = [
      { "keyValue":"Name","displayName": "Name", "paramName": "accountName" },
      { "keyValue":"Code","displayName": "Code", "paramName": "accountCode" },
      { "keyValue":"Tier","displayName": "Tier", "paramName": "tier" },
    ];

    setFilterCriteria(filterOptions);
    setFilterDisplayOptions(filterOptions.map((item) => item.displayName));
    setDefaultFilter(filterOptions[0].displayName);
    setFilter(filterOptions[0]);
  }

  // create useEffect to clear search query when a new filter is selected
  useEffect(() => {
    const placeholder = "Search " + filter.displayName;
    setSearchQueryPlaceholder(placeholder);
    setDealerSearchQuery("");
    getCashOutLimitDetailsData(0, paginationModel.pageSize, filter, "");
  }, [filter]);

  const handleFilterChange = (filter) => {
    // find the right filterCriteria based on the selected filter
    const selectedFilter = filterCriteria.find((item) => item.displayName === filter);
    setFilter(selectedFilter);

    // Check if the selected filter is "Tier" and update state accordingly
    if (selectedFilter.displayName === "Tier") {
      setShowTierDropdown(true);
    } else {
      setShowTierDropdown(false); // Hide the dropdown if another filter is selected
    }
  };

  const handleTierDropdownSelect = (selectedValue) => {
    // const selectedTierFilter = event.target.value;
    const selectedTierFilter = selectedValue;
    setDealerSearchQuery(selectedTierFilter);

    // when handling search, set pagination page to 0
    setPaginationModel({ pageSize: pageSize, page: 0 });
    getCashOutLimitDetailsData( 0, paginationModel.pageSize, filter, selectedTierFilter);

    handleCloseFilterTierDropdown();
  };

  const handleOpenFilterTierDropdown = (event) => {
    if (showTierDropdown) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleCloseFilterTierDropdown = () => {
    setAnchorEl(null);
  };

  function onSearchButtonClicked() {
    // when handling search, set pagination page to 0
    setPaginationModel({ pageSize: pageSize, page: 0 });
    getCashOutLimitDetailsData( 0, paginationModel.pageSize, filter, searchDealerQuery);
  }

  // Create Request Object for searchAllAccountEarmarkDetails API
  function createRequestObject(pageNumber, pageSize, selectedFilter, filterValue) {
    // Initialize all fields to null
    let requestObject = {
      // accountName: null,
      // accountCode: null,
      // vendorCode: null,
      // tier: null,
      // fromDate: null,
      // toDate: null,
      pageNumber: pageNumber,
      pageSize: pageSize,

      // sortOrder: null,
      // sortProperty: null,
    };
  
    // Set the appropriate field based on filterCriteria
    if (selectedFilter != null && selectedFilter != undefined && selectedFilter != "" && selectedFilter.paramName != "") {
      if (filterValue != null && filterValue != undefined && filterValue != "") {
        requestObject[selectedFilter.paramName] = filterValue;
      }
    }

    // sorting
    try{
      if (sortModel.length > 0) {
        // set sortProperty according to the field
        switch (sortModel[0].field) {
          case "accountName":
            requestObject.sortProperty = "NAME";
            break;
          case "accountCode":
            requestObject.sortProperty = "CODE";
            break;
          case "tier":
            requestObject.sortProperty = "TIER";
            break;
          case "daily":
            requestObject.sortProperty = "DAILY";
            break;
          case "weekly":
            requestObject.sortProperty = "WEEKLY";
            break;
          case "monthly":
            requestObject.sortProperty = "MONTHLY";
            break;
          default:
            break;
        }

        // set the sort order
        requestObject.sortOrder = sortModel[0].sort.toString().toUpperCase();
      } 
    } catch (error) {
      DebugLog("Error in sorting: " + error);
      requestObject.sortProperty = null;
      requestObject.sortOrder = null;
    }

    return requestObject;
  }

  /******* END of SEARCH & FILTER methods */


  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          <Grid 
            container 
            direction={'row'}
            alignItems={'center'}
            mb={2}
            ml={2}
            mt={1}
          >
            <Grid item>
              <GreetingHeader name={"Cash Out Limits"}></GreetingHeader>
            </Grid>

            <Box position="absolute" right={30} top={75}>
              <Grid
                  container
                  direction={'row'}
                  alignItems={'center'}
              >
                {/* SEARCH BAR */}
                <Box
                    backgroundColor={colors.grey[900]}
                    borderRadius="20px"
                    ml={5}
                    mr={2}
                >
                    <InputBase
                        sx={{ ml: 2, flex: 1 }}
                        placeholder={searchQueryPlaceholder}
                        value={searchDealerQuery}
                        onClick={handleOpenFilterTierDropdown}
                        onChange={(e) =>
                            setDealerSearchQuery(e.target.value)
                        }
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            onSearchButtonClicked();
                            e.preventDefault(); // Prevent form submission & page refresh
                          }
                        }}
                    />

                    <Menu
                      id="simple-menu"
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl) && showTierDropdown}
                      onClose={handleCloseFilterTierDropdown}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                      }}
                    >
                      {tierTabs.map((tier) => (
                          <MenuItem 
                            key={tier}
                            onClick={() => handleTierDropdownSelect(tier)}
                          >
                            {tier}
                          </MenuItem>
                        ))}
                    </Menu>

                    <IconButton 
                      type="button" 
                      sx={{ p: 1 }}
                      onClick={onSearchButtonClicked}
                    >
                        <SearchIcon/>
                    </IconButton>
                </Box>

                

                <ToolbarFilterButton
                    options={filterDisplayOptions}
                    defaultOption={defaultFilter}
                    onChange={handleFilterChange}
                    name={"FILTERS"}
                />
            </Grid>
          </Box>
          </Grid>
          {/* Greetings Header */}

          {/* Highlight Stats */}
          <EarmarkHighlightStats
            highlight0={"Total Dealers"}
            highlightTotal={totalAccounts}
            {...props}
          ></EarmarkHighlightStats>
          {/* Highlight Stats */}

          {/* On Hold Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            <SectionHeader
              sectionIcon={"../../assets/common/CashOut.svg"}
              sectionHeading={"Cash Out Limits"}
            ></SectionHeader>

            {cashOutLimitDetails.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                    borderRadius: 'inherit',
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                     color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{row: 'dataGridRow'}}
                  rows={cashOutLimitDetails}
                  columns={cashOutLimitsColumnHeader}
                  // components={{ Toolbar: CustomToolbar }}
                  checkboxSelection
                  onSelectionModelChange={handleSelectionChange}
                  selectionModel={selectedRows}
                  selection 
                  disableSelectionOnClick // Disable row selection on row click
                  
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  // pagination
                  paginationModel={paginationModel}
                  paginationMode="server"
                  // keepNonExistentRowsSelected
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[10, 15, 30, 45, 60]} // Include 10 in the options
                  autoHeight

                  onRowClick={handleRowClick}

                  sortModel={sortModel}
                  onSortModelChange={(model) => setSortModel(model)}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>
          

          {cashOutLimitDetails.length > 0 ? (
            <Box item mt={2} ml={1}>
              <Typography>
                <span>Jump to page: </span>
                <select 
                  value={paginationModel.page + 1} 
                  onChange={handlePageJump}
                  >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          <SetCashOutLimitDialog
            open={openCashOutLimitDialog}
            onClose={handleCloseCashOutLimitDialog}
            onSaveButtonClick={saveCashOutLimit}
            onSaveGlobalButtonClick={saveGlobalCashOutLimit}
            isGlobalCashOutLimit={isGlobalCashOutLimitDialog}
            data={selectedItem}
            globalData={globalCashOutLimitDetails}
            timeline={cashOutTimelineDetails}
            totalNoOfPages={timelineTotalNoOfPages}
            onPageChange={handleTimelinePageChange}
            tiersArray={tierTabs}
            onNewTierSelected={handleSelectedTierChangeForGlobal}
          />

          {/* Action Buttons */}
          <Grid container mt={1} justifyContent={"flex-end"} pb={3}>
              <Stack direction="row" spacing={2} justifyContent={"flex-end"}>

                {
                  globalSettingsButton ? (
                    <CustomButton
                      btnBG={colors.grey[900]}
                      btnColor={colors.grey[100]}
                      btnTxt={"GLOBAL SETTINGS"}
                      onClick={getGlobalCashOutLimitDetails}
                    ></CustomButton>
                  ) : (
                    ""
                  )
                }

                { downloadButtonVisible ? (
                  <DownloadDropdownButton
                    onFileTypeSelected={downloadCashOutReport}
                  />
                ) : (
                  ""
                )}
              </Stack>
            </Grid>

          {/* Action Buttons */}

          {/* activity list */}
          <Grid container>
            
          <UserActivityInfo  
            type={"CashOutLimits"} 
            data={cashOutActivityDetails}
            ondateRangeChange={handleDateRangeChange}
            totalNoOfPages={activityTotalNoOfPages}
            onPageChange={handleActivityPageChange}
            />
          {/* activity list */}
          </Grid>
          
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}
